import { ReactElement } from 'react'
import {
  LearnWrapper,
  AccordianWrapper,
  AccordianItem,
  AccordianHeader,
  CourseTitle,
  CustomToogle,
  SubjectContainer,
  LearnPageWrapper
} from './subcomponents'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import {
  IconButton,
  Loader,
  SectionTitle,
  TostMessage
} from '../../../components'
import { capitalize, getSubjectLogo } from '../../../helpers'
import strings from '../../../locale/en'
import determineCourseFromBatch from '../../../helpers/determineCourseFromBatch'
import { getChapter } from '../../../redux/learn/actions'
import { updateHasError } from '../../../redux/learn/actions'

const Learn = (): ReactElement => {
  const {
    isMenuOpen,
    subjects,
    batchList = [],
    isLoading,
    batchId,
    hasError = false
  } = useSelector(
    (state: RootState) => ({
      isMenuOpen: state.menu.isMenuOpen,
      subjects: state.learn.subjects,
      batchId: state.learn?.batchId,
      batchList: state.user?.userInfo?.userDetail?.batchList,
      isLoading: state.learn?.isLoading,
      hasError: state.learn?.hasError
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const coureseList = determineCourseFromBatch(batchList)
  const {
    learn: { title, helpText }
  } = strings
  const selectedBatchIndex = batchList.findIndex(
    (batch) => batch?.id === batchId
  )

  return (
    <LearnPageWrapper>
      <LearnWrapper isMenuOpen={isMenuOpen}>
        <SectionTitle title={title} helpText={helpText} />
        <div>
          <TostMessage
            show={hasError}
            onCloseHandler={() => dispatch(updateHasError(false))}
            message={strings.learn.failedTofetchChapters}
          ></TostMessage>
          <AccordianWrapper
            defaultActiveKey={`${selectedBatchIndex}`}
            key="subjects-accordian"
          >
            {coureseList.map((course, index) => {
              return (
                <AccordianItem eventKey={`${index}`} key={`subject-key-${index}`}>
                  <AccordianHeader>
                    <CourseTitle>{course.courseName}</CourseTitle>
                    <CustomToogle eventKey={`${index}`} />
                  </AccordianHeader>
                  <SubjectContainer>
                    {isLoading ? (
                      <Loader />
                    ) : (
                      subjects.map((subject, index) => (
                        <IconButton
                          src={getSubjectLogo({
                            subject: subject?.courseName
                          })}
                          isBold
                          title={capitalize(subject?.courseName)}
                          key={`subject-${index}`}
                          onSubmit={() => {
                            dispatch(
                              getChapter({
                                subjectId: subject?.id,
                                subjectName: subject?.courseName,
                                batchId: batchId
                              })
                            )
                          }}
                        />
                      ))
                    )}
                  </SubjectContainer>
                </AccordianItem>
              )
            })}
          </AccordianWrapper>
        </div>
      </LearnWrapper >
    </LearnPageWrapper>
  )
}

export default Learn
